import axios, { type CancelTokenSource } from 'axios';
import { defineStore } from 'pinia';
import { useUser } from './user';
import { useActiveSeason } from './active-season';
import type { QuickSearchProductDto } from '@/ApiClient';

export const useSearch = defineStore('search', {
  state: () => ({
    cancelObj: null as CancelTokenSource | null,
    searchResults: [] as QuickSearchProductDto[],
  }),

  actions: {
    async quickSearch(
      query: string | null | undefined,
      { brandId, take, skip }: { brandId?: number; take?: number; skip?: number } = {}
    ) {
      if (!query) return { searchResults: [] as QuickSearchProductDto[] };

      if (this.cancelObj) {
        this.cancelObj.cancel();
      }

      this.cancelObj = axios.CancelToken.source();

      const resolvedBrandId = brandId ?? useUser().brandId;
      const activeSeasonId = useActiveSeason().activeSeasonId ?? undefined;

      try {
        const searchResults = await this.$api.search_QuickSearch(
          { brandId: resolvedBrandId, query, take, skip, activeSeasonId },
          { cancelToken: this.cancelObj.token }
        );

        this.searchResults = searchResults;
        return { searchResults };
      } catch (err) {
        if (!axios.isCancel(err)) throw err;
        return { searchResults: [] as QuickSearchProductDto[] };
      }
    },
  },
});
